import axios from 'axios';

import { CurrentUser, RoleType } from '@feature/security';
import { getData, wait } from '@feature/utils';

import { ChangePasswordRequest, LoginRequest } from './LoginTypes';

export function login(payload: LoginRequest) {
  return axios.post(payload.useLdapLogin ? '/auth/login/ldap' : '/auth/login', payload).then(getData);
}

export function logout() {
  // wait for other possible requests, like telemetry sending
  return wait(400).then(() => axios.post('/auth/logout').then(getData));
}

export function getCurrentUser() {
  return axios.get<CurrentUser>('/auth/current').then(getData);
}

export function changeCurrentRole(roleType: RoleType) {
  return axios.put(`/auth/change-role/${roleType}`);
}

export function changePassword(payload: ChangePasswordRequest) {
  return axios.put('/auth/password', payload).then(getData);
}
